module.exports = __webpack_public_path__ + "img/vision.bb3d963e.png";